module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlanding/adminlanding.component.scss
// module id = ./src/app/adminlanding/adminlanding.component.scss
// module chunks = main